export function verifyWhiteLabelPermission(user: string, path: string) {
  return !((path === "/saldo" && !user?.includes("@barte")) 
  || (path === "/transfer" && !user?.includes("@barte")) 
  || (path === "/history-transfer" && !user?.includes("@barte")) 
  || (path === "/invoices" && !user?.includes("@barte"))
  || (path === "/financeiro" && !user?.includes("@barte"))
  || (path === "/contestation" && !user?.includes("@barte"))
  || (path === "/feature-toggles" && !user?.includes("@barte")));
}